import {useDispatch, useSelector} from 'react-redux'
import BasePopup, {PopupProvides} from '../common/popup/BasePopup'
import FileUploadForm from './FileUploadForm'
import {getDocumentState, loadDocuments} from '../../redux/documentSlice'
import {getAdminState, setAdminSelectedCompany} from '../../redux/adminSlice'
import {GetAdminCompanyRequest, AdminPanelCompanyDetailDTOApiData} from '../../api/data-contracts'
import {Api_Admin_GetCompany} from '../../apiClient/apiClient'
import {setIsLoading, postRequestAsync} from '../../redux/commonSlice'

function DocumentReuploadButton(props: {guidId: string}) {
  const documentState = useSelector(getDocumentState)
  const adminState = useSelector(getAdminState)
  const dispatch = useDispatch()

  const loadCompanyData = async () => {
    const body: GetAdminCompanyRequest = {
      companyGuidId: adminState?.company?.company?.guid ?? '',
    }
    dispatch(setIsLoading(true))
    await dispatch<any>(
      postRequestAsync({
        postRequestFunction: Api_Admin_GetCompany,
        body: body,
      })
    )
      .unwrap()
      .then(async function (response: AdminPanelCompanyDetailDTOApiData) {
        dispatch(setAdminSelectedCompany(response.data))
        dispatch(setIsLoading(false))
      })
  }

  return (
    <div className='' title='DOKUMAN_YENIDEN_YUKLE'>
      <BasePopup
        title='DOKUMAN_YENIDEN_YUKLE'
        size='lg'
        modalOpener={
          <a type='button' className='btn btn-sm btn-icon btn-light btn-info'>
            <i className='fa-solid fa-upload'></i>
          </a>
        }
      >
        {(providers: PopupProvides) => {
          return (
            <FileUploadForm
              handleClose={async () => {
                await dispatch<any>(loadDocuments())
                await loadCompanyData()
                providers.handleClose()
              }}
              guidId={props.guidId}
              documentTypeId={documentState.selectedFolder?.id ?? 0}
              companyGuidId={adminState?.company?.company?.guid ?? ''}
            />
          )
        }}
      </BasePopup>
    </div>
  )
}

export default DocumentReuploadButton
